import React from 'react'

import { ReactComponent as HandWaving } from '../../assets/icons/HandWaving.svg';

import classes from './WelcomeMessage.module.scss';


const WelcomeMessage = () => {
  return (
    <div className={classes.content}>
        <HandWaving/>
        <span className={`bold-24 ${classes.title}`}>¡Bienvenido a Melo!</span>
        <span className={`bold-20 ${classes.subtitle}`}>Antes de comenzar, queremos conocerte mejor</span>
        <span className={`medium-16 ${classes.description}`}>
            Completa los siguientes datos para asegurarnos de que aproveches 
            al máximo todas las funcionalidades tenemos para ti
        </span>
    </div>
  )
}

export default WelcomeMessage